import { FilterItemType } from '@otp/ui';
import { TFunction } from 'i18next';
import { Tag, User } from 'src/graphql/generated/graphql';
import { getFullName } from 'src/utils/user-data';

export const getFilterConfig = ({
  t,
  users,
  tags,
}: {
  t: TFunction;
  users: Partial<User>[];
  tags: Tag[];
}) => [
  {
    id: 'tagIds',
    size: 4,
    type: FilterItemType.Multiselect,
    props: {
      multiple: true,
      inputProps: {
        placeholder: t('common.tags'),
        name: 'tagIds',
        label: t('common.tags'),
      },
      options: tags.map((tag) => ({
        value: tag.id,
        name: tag.name,
      })),
    },
  },
  {
    id: 'createdByUserId',
    size: 4,
    type: FilterItemType.Select,
    props: {
      inputProps: {
        placeholder: t('resources.list.columns.added-by'),
        name: 'createdByUserId',
        label: t('resources.list.columns.added-by'),
      },
      options: users.map((user) => ({
        value: user.id,
        name: getFullName(user, ' '),
      })),
    },
  },
];
